const colors = {
  blue: '--blue',
  orange: '--orange',
  green: '--green',
  red: '--red',
  black: '--black',
  gray: '--gray',
  white: '--white'
}
export default colors
